import { Component, EventEmitter, Input, NgModule, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { CommonModule } from '@angular/common';
import { WRxBase } from '@wipo/w-angular/shared';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'w-notification-bar',
    templateUrl: './w-notification-bar.component.html',
    animations: [
        trigger('openClose', [
            state('open', style({
                height: 'auto',
                display: 'block'
            })),
            state('closed', style({
                height: '0px',
                display: 'none'
            })),
            transition('open => closed', [
                animate('1s')
            ]),
        ])
    ],
    standalone: false
})
/*
@id w-notification-bar
@name w-notification-bar
@status release
@description
*/
export class WNotificationBarComponent extends WRxBase implements OnChanges, OnDestroy {

  // can set the "message" and manipulate "visible"
  @Input() message?: string; // pass the notification message
  @Input() visible: boolean = false ;
  @Input() canClose: boolean = true; // has close button
  @Input() messages?: Observable<string> ;// or watch obserable for messages
  @Output() wClosed = new EventEmitter<void>();

  ngOnChanges(changes: SimpleChanges): void {
    const messages = changes['messages'];
    if (messages){
      if (messages.currentValue) {
        messages.currentValue.pipe(takeUntil(this.destruction)).subscribe((value: string) =>{
          this.message = value;
          this.visible = true;
        })
      }
    }
  }
  
  doClose() {
    this.visible = false;
    this.wClosed.emit();
  }
}
@NgModule({
  imports: [CommonModule],
  exports: [WNotificationBarComponent],
  declarations: [WNotificationBarComponent]
})
export class WNotificationBarModule { }
